<template>
  <div class="little-left">
    <!-- 设备 -->
    <colalist />
    <!-- 灾害模拟 -->
    <colaght />
  </div>
</template>
<script>
import colalist from "./colsts/colalist.vue";
import colaght from "./colsts/colaright";
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    colalist,
    colaght,
  },
};
</script>
<style lang="less" scoped>
.little-left {
  width: 12%;
  height: 58%;
  position: absolute;
  left: 20%;
  top: 10%;
  overflow: hidden;
}
</style>